export default __webpack_public_path__ + "static/media/plant.b7507110.svg";